var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-card-title", { attrs: { "primary-title": "" } }, [
        _c("h3", { staticClass: "headline" }, [_vm._v("Edit channels")])
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _vm.alerts.length > 0
            ? _c(
                "div",
                [
                  _c("v-alert", { attrs: { type: "error", value: true } }, [
                    _c("h4", [_vm._v(_vm._s(_vm.alert.title))]),
                    _vm._v(
                      "\n        " + _vm._s(_vm.alert.description) + "\n      "
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.alerts.length == 0 && _vm.channelsStruct.length > 1
            ? _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { md3: "" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Linked fields" },
                        model: {
                          value: _vm.linkedFields,
                          callback: function($$v) {
                            _vm.linkedFields = $$v
                          },
                          expression: "linkedFields"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "pt-3", attrs: { md3: "" } },
                    [
                      _vm.linkedFields
                        ? _c(
                            "v-menu",
                            {
                              attrs: {
                                slot: "append",
                                "offset-x": "",
                                "open-on-hover": ""
                              },
                              slot: "append"
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    slot: "activator",
                                    color: "warning"
                                  },
                                  slot: "activator"
                                },
                                [_vm._v("warning")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-alert",
                                { attrs: { type: "warning", value: true } },
                                [
                                  _c("h4", [
                                    _vm._v("Linked fields option is active")
                                  ]),
                                  _vm._v(
                                    "\n              Fields accross channels are linked together."
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n              Modifying a field on one channel, applies the value to the others."
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n              Use with caution.\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.alerts.length == 0
            ? _c(
                "v-tabs",
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab"
                  }
                },
                [
                  _c("v-tab", [_vm._v("Global parameters")]),
                  _vm._v(" "),
                  _c("v-tab", [_vm._v("Devices")]),
                  _vm._v(" "),
                  _vm._l(_vm.channelsStruct, function(sch, i) {
                    return _c("v-tab", { key: i }, [
                      _vm._v("Channel #" + _vm._s(i + 1))
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c("form-schema", {
                        ref: "global",
                        attrs: { schema: _vm.schema, "no-submit": true },
                        model: {
                          value: _vm.formValues,
                          callback: function($$v) {
                            _vm.formValues = $$v
                          },
                          expression: "formValues"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c("form-schema", {
                        ref: "device",
                        attrs: {
                          value: _vm.deviceValues,
                          schema: _vm.devicesSchema,
                          "no-submit": true,
                          disabled: _vm.channelValues.length > 0
                        },
                        on: { input: _vm.handleDeviceFormInput }
                      }),
                      _vm._v(" "),
                      _vm.channelsStruct.length == 0
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-btn",
                                { on: { click: _vm.handleCreateSingle } },
                                [_vm._v("Create a single channel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                { on: { click: _vm.handleCreateTriplet } },
                                [_vm._v("Create a triplet")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.channelsStruct, function(sch, i) {
                    return _c(
                      "v-tab-item",
                      { key: i },
                      [
                        _c("form-schema", {
                          ref: "channelForm",
                          refInFor: true,
                          attrs: {
                            value: _vm.channelValues[i],
                            schema: _vm.channelsStruct[i],
                            "no-submit": true
                          },
                          on: {
                            input: function($event) {
                              return _vm.$set(_vm.channelValues, i, $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                disabled: _vm.channelsStruct.length == 0
              },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v("Submit")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a6176e7", { render: render, staticRenderFns: staticRenderFns })
  }
}